import { createExcelAndDownload } from '../../../utils/reportExcelExport';

export function ExpenseReport(expenses) {
    const customHeadings = [
        { key: "title", label: "Title" },
        { key: "amount", label: "Amount" },
        { key: "category", label: "Category" },
        { key: "created_by.name", label: "Created By" },
        { key: "created_at", label: "Date", isDate: true },
    ];
    createExcelAndDownload("All Expense Report", expenses, customHeadings);
}
